import React from 'react';
import '../../FormBuilder.css';

const FetchGPSElement = ({ component, isRequired }) => {
  const renderElement = () => {
    return (
      component.elementName === 'fetchGps' && (
        <label className='titleTextLbl'>
            {component.fieldName || "Fetch GPS"}
            <span className='requiredContainer' style={{ color: 'red' }}>{isRequired(component)}</span>
        </label>
      )
    );
  };

  return (
    <div className='renderAllElements'>
      {renderElement()}
    </div>
  );
};

export default FetchGPSElement;
